module.exports = __webpack_public_path__ + "static/media/landing-slider-img-1-mobile.2f3120d0.jpg";